export default "__VITE_ASSET__DGAV1pE2__"